module.exports = __webpack_public_path__ + "assets/images/electoral-college/icons/nomination-of-electors.svg?v=bc27f798";